export const TIMEOUT = {
  COPY: 1500,
  SHORT: 500,
  DEFAULT: 2500,
  LONG: 900000,
} as const
